import { create } from 'zustand';

export type AuthMode = 'login' | 'signup';

interface AuthModalState {
  isOpen: boolean;
  mode: AuthMode;
  /** Open the auth modal, optionally in a specific mode (default: login). */
  open: (mode?: AuthMode) => void;
  close: () => void;
  setMode: (mode: AuthMode) => void;
}

/**
 * UI-only state for the global auth modal. Lives in Zustand so any component
 * (header sign-in, comment gate, …) can open it without prop-drilling.
 */
export const useAuthModal = create<AuthModalState>((set) => ({
  isOpen: false,
  mode: 'login',
  open: (mode = 'login') => set({ isOpen: true, mode }),
  close: () => set({ isOpen: false }),
  setMode: (mode) => set({ mode }),
}));
